export enum ACTIONS {
  setEntries = 'SET_ENTRIES',
}

export type State = {
  featuredEntries: string;
};

export type Action = { type: ACTIONS.setEntries; payload: string[] };
